import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { Body } from '../Shell/Shell'
import { PublicLogin } from '../Shell/Login/Login'
import { parseUrlQuery } from 'utilities'
import { getAuthRedirectUrl } from 'utilities'
import { Spinner } from '../Loaders/Loaders'
import { withRouter } from 'react-router'

class LoginRedirector extends Component {
  redirect = () => {
    const search = parseUrlQuery(this.props.location.search)
    this.props.history.replace((search.from || '/') + (search.search || ""))
  }
  render() {
    const { checkingAuthState, location } = this.props
    return (
      <Body className="login-redirector">
        {checkingAuthState ? (
          <Spinner className="page-loader" />
        ) : (
          <PublicLogin onLogin={this.redirect} location={location} />
        )}
      </Body>
    )
  }
}
export default connect(state => ({
  checkingAuthState: state.auth.checkingAuthState
}))(LoginRedirector)

export const LoginRedirectSwitch = ({ location }) => {
  return <Redirect to={getAuthRedirectUrl(location)} />
}

export let InRouteRedirector = ({ location, loggedIn }) =>
  !loggedIn ? <Redirect to={getAuthRedirectUrl(location)} /> : null

InRouteRedirector = compose(
  withRouter,
  connect(state => ({
    loggedIn: state.auth.loggedIn
  }))
)(InRouteRedirector)



// WEBPACK FOOTER //
// ./src/components/LoginRedirector/LoginRedirector.js